import axiosInterceptor from "../../utils/axiosInterseptor";

export const signIn = (data) => axiosInterceptor.post(`admin/adminLogin`, data)